import axios from "axios";
import { api } from "~/router/apiConfig";

export function list(contractId, query = null) {
  return axios.get(
    api.path("contractHistory.index", { contractId: contractId }),
    { params: query }
  );
}


export function show(contractId, entityId, query = null) {
  return axios.get(
    api.path("contractHistory.show", { contractId: contractId, entityId: entityId }),
    { params: query }
  );
}

